import {
  RECEIVE_AND_DEFER_SEARCH_RESPONSE,
  RECEIVE_IN_STOCK_FILTERED_PRODUCTS,
  RECEIVE_SEARCH_RESPONSE,
  REQUEST_SEARCH,
  SET_SEARCH_OOS_MESSAGING,
  UPDATE_SEARCH_LIMIT
} from 'constants/reduxActions';

import { firePixelServer } from 'actions/pixelServer';
import { decorateReco } from 'apis/cloudcatalog';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { trackError } from 'helpers/ErrorUtils';
import { toUSD } from 'helpers/NumberFormats';

export function requestSearch({ url, isFresh }) {
  return {
    type: REQUEST_SEARCH,
    url,
    isFresh
  };
}

export function receiveSearchResponse(response) {
  return {
    type: RECEIVE_SEARCH_RESPONSE,
    response
  };
}

export function setOosMessaging(response) {
  return {
    type: SET_SEARCH_OOS_MESSAGING,
    response
  };
}

export function fireSearchPixel(term, results, facets) {
  return firePixelServer('search', {
    results: (results || []).map(result => ({
      sku: result.productId,
      styleId: result.styleId
    })),
    facets, term
  });
}

export function receiveInStockFilteredProducts(inStockFilteredProducts) {
  return {
    type: RECEIVE_IN_STOCK_FILTERED_PRODUCTS,
    inStockFilteredProducts
  };
}

export function updateProductLimit(limit) {
  return {
    type: UPDATE_SEARCH_LIMIT,
    limit
  };
}

// If HYDRA_BRAND_NAME_SEARCH is not made permanent, this action and all its
// associated functionality can be removed.
export function receiveAndDeferSearchResponse(deferredSearchResponse) {
  return {
    type: RECEIVE_AND_DEFER_SEARCH_RESPONSE,
    deferredSearchResponse
  };
}

export function filterDecoratedResponse(availableProducts, productsList) {
  const updatedProductsList = [];
  productsList.map(v => {
    const product = { ...v };
    if (availableProducts[v.styleId]) { // Check if in stock, otherwise remove
      // Update original price
      product.originalPrice = toUSD(availableProducts[v.styleId].listPrice);
      // Update price
      product.price = toUSD(availableProducts[v.styleId].price);
      // Add to our updated list
      updatedProductsList.push(product);
    }
  });
  return updatedProductsList;
}

export function decorateSearchResponse(productsList) {
  const styleIds = [];
  productsList.map(v => {
    styleIds.push(v.styleId);
  });
  return (dispatch, getState) => {
    const { environmentConfig: { api: { cloudcatalog: cloudcatalogInfo } } } = getState();
    decorateReco(cloudcatalogInfo, { styleIds })
      .then(fetchErrorMiddleware)
      .then(response => {
        if (response) {
          const filteredProducts = filterDecoratedResponse(response, productsList);
          dispatch(receiveInStockFilteredProducts(filteredProducts));
        }
      })
      .catch(e => {
        trackError('NON-FATAL','Could not retrieve decorated search response', e);
      });
  };
}
